import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { CELL_ISOLATION_SPECIAL_CONVERTER_TOKEN, CellIsolationSpecialConverter } from './cell-isolation-special.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        cellIsolationSpecialFeature: {
          module: () => import('./cell-isolation-special.module').then((m) => m.CellIsolationSpecialModule),
          cmsComponents: ['cell_isolation_special'],
        },
      }
    }),
    {
      provide: CELL_ISOLATION_SPECIAL_CONVERTER_TOKEN,
      useExisting: CellIsolationSpecialConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        cell_isolation_special: CELL_ISOLATION_SPECIAL_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class CellIsolationSpecialFeatureModule {}
